import { LogoPay } from "@au-schein-de/au-ui-library";
import { useTranslation } from "react-i18next";
import { DrAnsayPayBannerPattern } from "./dransay-pay-banner-pattern.component";

interface DrAnsayPayProfileBannerProps {
	onLearnMoreClick: () => void;
}

/** DrAnsay Pay promo strip at the top of the user profile dropdown menu. */
export function DrAnsayPayProfileBanner({
	onLearnMoreClick,
}: DrAnsayPayProfileBannerProps) {
	const { t } = useTranslation("auth");
	return (
		<div
			className="relative mb-6 min-h-[124px] w-full shrink-0 overflow-hidden rounded-xl bg-ansay-900"
			data-testid="dransay-pay-profile-banner"
		>
			<DrAnsayPayBannerPattern className="pointer-events-none absolute right-0 top-0 h-[101px] w-[154px] text-white opacity-[0.06]" />
			<div className="relative z-10 flex min-h-[124px] flex-col p-4">
				<LogoPay
					title="DrAnsay Pay"
					variant="light"
					size={27}
					className="shrink-0"
					data-testid="dransay-pay-profile-banner-logo"
				/>
				<div className="mt-[11px] flex flex-1 items-end justify-between gap-2">
					<div className="flex flex-col gap-1">
						<p className="text-body-lg-emphasis text-white">
							{t("dransayPay.banner.title")}
						</p>
						<p
							className="max-w-[192px] pb-2 text-caption text-white md:max-w-[202px]"
							data-testid="dransay-pay-profile-banner-subtitle"
						>
							{t("dransayPay.banner.subtitle")}
						</p>
					</div>
					<button
						type="button"
						onClick={onLearnMoreClick}
						className="shrink-0 cursor-pointer self-end pb-2 text-body-sm-emphasis text-ansay-light"
						data-testid="dransay-pay-profile-banner-learn-more"
					>
						{t("dransayPay.banner.learnMore")}
					</button>
				</div>
			</div>
		</div>
	);
}
